import { type ComponentProps } from "react";
import { Button } from "../../design-system";

/* The primary wizard CTA. The Claude Design's onboarding button is the
 * off-white (#F5F4F1) ground with maroon (#280611) text — high-contrast on the
 * maroon onboarding surface. The shared Button has no matching variant, so we
 * base on `secondary` (neutral border + disabled handling) and override the
 * enabled bg/text via the --onb-cta-* tokens (defined light in ai21-brand.css,
 * kept off-white on the maroon ground in app-theme.css). Disabled state falls
 * back to the Button's own muted styling. */
export function WizardCta({
  style,
  disabled,
  ...rest
}: ComponentProps<typeof Button>) {
  return (
    <Button
      variant="secondary"
      size="lg"
      disabled={disabled}
      style={
        disabled
          ? style
          : {
              background: "var(--onb-cta-bg)",
              color: "var(--onb-cta-fg)",
              borderColor: "var(--onb-cta-bg)",
              ...style,
            }
      }
      {...rest}
    />
  );
}
